// extracted by mini-css-extract-plugin
export default {"outView":"ViewHomeTopAdArea_outView__HLFLk","img":"ViewHomeTopAdArea_img__3YxQs","adText":"ViewHomeTopAdArea_adText__L-9+G"};